// Copied from PaySG
// https://github.com/opengovsg/paysg/blob/a9b5aee39aaecf3009b8822b815de8c76207aacf/frontend/src/utils/scroll.ts

export function scrollToTop() {
  document.body.scrollTop = 0
  document.documentElement.scrollTop = 0
}
